import { Pipe, PipeTransform, inject } from '@angular/core';
import * as showdown from 'showdown';

import { TerraHtmlSanitizerService } from '@ninety/terra';

import { MazMessage } from '../models/maz-message';
import { MazMessageSender } from '../models/maz-message-sender.enum';

@Pipe({
  name: 'mazMessageHtml',
  standalone: true,
})
export class MazMessageHtmlPipe implements PipeTransform {
  private terraHtmlSanitizerService = inject(TerraHtmlSanitizerService);

  transform(message: MazMessage): string {
    if (message.sender === MazMessageSender.user) return this.terraHtmlSanitizerService.sanitize(message.text);
    const converter = new showdown.Converter();
    const html = converter.makeHtml(message.text);
    return this.terraHtmlSanitizerService.sanitize(html, true);
  }
}
